import { render, staticRenderFns } from "./EditNavLiteralDisplayOptions.vue?vue&type=template&id=39c1edda&"
import script from "./EditNavLiteralDisplayOptions.vue?vue&type=script&lang=js&"
export * from "./EditNavLiteralDisplayOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports